import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import moment from 'moment';

import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import DatePicker from '@/shared/components/input/DatePicker';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { falseFunc, isBeforeMinimum } from '@/shared/utils/validationHelpers';
import messages from './taskMessages';

export default class ChangeSubtaskDeadlineModal extends Component {
  state = {
    deadline: moment.utc(),
    selectedSubtask: null,
  };

  componentDidMount() {
    this.form = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;

    if (prevProps.show !== show) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({
        deadline: moment.utc(),
        showValidation: false,
        selectedSubtask: null,
      }));
    }
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  validate() {
    if (!this.form || !this.form.current) return false;
    const { selectedSubtask, deadline } = this.state;
    if (!selectedSubtask || !selectedSubtask.id) return false;
    if (isBeforeMinimum(deadline)) return false;

    return this.form.current.reportValidity();
  }

  deadlineChanged = input => {
    this.setState({
      deadline: input,
    });
  };
  subtaskChanged = event => {
    const { subtasks } = this.props;
    const subtaskId = event.target.value;
    const subtask = subtasks.find(x => x.id === subtaskId);

    this.setState({
      selectedSubtask: subtask,
    });
  };
  onSave = () => {
    const { deadline, selectedSubtask } = this.state;
    const { onSave } = this.props;
    if (!this.validate()) return Promise.reject(new Error('invalid form'));

    const parameters = {
      subtaskTemplateId: selectedSubtask.id,
      deadline,
    };

    return onSave(parameters);
  };

  render() {
    const { show, intl, subtasks } = this.props;
    const { deadline, dateFocused, selectedSubtask, showValidation } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeSubtaskDeadline)}
        show={show}
        onClose={this.closeModal}
        disabled={showValidation && !this.validate()}
        onSave={this.onSave}
        onHoverSave={() => this.setState({ showValidation: true })}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              <div
                className={classNames('form-group', {
                  'has-error': showValidation && (!selectedSubtask || !selectedSubtask.id),
                })}
              >
                <label className="control-label col-sm-3">
                  {intl.formatMessage(messages.Subtask)}
                </label>
                <div className="col-md-6">
                  {subtasks && (
                    <select
                      onChange={this.subtaskChanged}
                      className="form-control form-field"
                      value={(selectedSubtask && selectedSubtask.id) || ''}
                    >
                      {!selectedSubtask && (
                        <option value="">{intl.formatMessage(messages.SelectASubtask)}</option>
                      )}
                      {subtasks.map(subtask => (
                        <option key={subtask.id} value={subtask.id}>
                          {intl.formatMessage(
                            listItemMsg('taskTemplate', subtask.id, subtask.name),
                          )}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </div>

              <div
                className={classNames('form-group', {
                  'has-error': showValidation && isBeforeMinimum(deadline),
                })}
              >
                <label className="control-label col-sm-3">
                  <FormattedMessage {...messages.Deadline} />
                </label>
                <div className="col-md-6">
                  <DatePicker
                    placeholder={intl.formatMessage(messages.Deadline)}
                    date={deadline}
                    onDateChange={this.deadlineChanged}
                    focused={dateFocused}
                    onFocusChange={({ focused }) => this.setState({ dateFocused: focused })}
                    id="taskDeadline"
                    block
                    small
                    isOutsideRange={falseFunc}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
